<!-- @format -->

<div
  class="product-card-wrapper hmf-grid hmf-span-12"
  [class.hmf-mb-s]="!isSponsored()"
  [class.hmf-mb-0]="isSponsored()"
  [class.disabled]="isDisabled()">
  <div class="product-card-badge hmf-span-10">
    @let customBadgeInfo = customBadge();
    @if (badge()) {
      <hmf-badge [badgeName]="badge()" />
    } @else if (customBadgeInfo) {
      <hmf-badge
        ngSkipHydration
        [style]="{
          background: 'var(' + customBadgeInfo.background + ')',
          color: 'var(' + customBadgeInfo.textColor + ')'
        }"
        [badgeName]="customBadgeInfo.text">
      </hmf-badge>
    }
  </div>
  <div
    id="product-card"
    class="product-card-content hmf-span-12">
    <div class="inner-wrapper hmf-pb-xxs" [class.inner-wrapper--min-height]="!isHybridPLA()">
      <!-- This will be switched out for the product image component -->
      <div class="product-card-image hmf-mt-xxs hmf-mb-xs">
        <a
          role="button"
          class="image"
          tabindex="-1"
          aria-hidden="true"
          [href]="isDisabled() ? 'javascript:void(0)' : updatedAssetSeoUrl()"
          [class.disabled]="isDisabled()"
          [title]="title()"
          (click)="productCardClicked($event)">
          <span class="product-image-span hmf-display-flex hmf-justify-content-center">
            <homefield-product-image
              #productCardImage
              [imageUrl]="imageUrl()"
              [ecode]="ecode()"
              [defaultColor]="colors() && colors().length > 0 ? colors()[0] : null"
              [productName]="title()"
              [selectedSwatchColor]="selectedSwatchColor()"
              [isLCPImage]="isLCPImage()"
              [isNgOptimizedImageSupported]="isNgOptimizedImageSupported()">
            </homefield-product-image>
          </span>
        </a>
      </div>

       @if (moreOptionsPDPEnabled() && shouldShowMoreOptions()) {
        <div class="more-options-container hmf-display-flex hmf-justify-content-center hmf-mb-xs">
          <a
            hmf-text-link
            class="more-options-link hmf-text-decoration-none"
            endIconName="arrow-right-outline"
            size="medium"
            tabindex="0"
            variant="tertiary"
            [linkURL]="updatedAssetSeoUrl()"
            (click)="productCardClicked($event)"
            (keydown.enter)="productCardClicked($event)">
              <span class="hmf-display-inline hmf-display-lg-none">More Options</span>
              <span class="hmf-display-none hmf-display-lg-inline">More Options Available</span>
          </a>
        </div>
      } @else if (moreOptionsQVEnabled() && shouldShowMoreOptions()) {
        <div class="more-options-container hmf-display-flex hmf-justify-content-center hmf-mb-xs">
          <button
            hmf-action-text
            class="more-options-link hmf-text-decoration-none"
            endIconName="arrow-right-outline"
            size="medium"
            variant="tertiary"
            (click)="handleQVClick()">
              <span class="hmf-display-inline hmf-display-lg-none">More Options</span>
              <span class="hmf-display-none hmf-display-lg-inline">More Options Available</span>
          </button>
        </div>
      } @else {
        <div class="swatches-container hmf-display-flex hmf-justify-content-center hmf-mb-xs">
          <shared-totf-components-product-card-color-swatches
            [colors]="colors()"
            [ecode]="ecode()"
            [assetSeoUrl]="pdpUrl()"
            [isLazy]="!isLCPImage()"
            (selectedSwatchColorChange)="colorSwatchChanged($event)"
            (extraColorsClick)="productCardClicked($event)">
          </shared-totf-components-product-card-color-swatches>
        </div>
      }

      <a
        class="product-title-link hmf-body-m hmf-header-m-xs hmf-mb-xxs hmf-mb-m-0"
        tabindex="0"
        [href]="updatedAssetSeoUrl()"
        [title]="title()"
        [attr.aria-label]="productCardAriaLabel()"
        (click)="productCardClicked($event)">
        {{ title() }}
      </a>

      @if (isOOS()) {
        <div
          class="oos-container"
          [class]="{ 'hmf-mb-m': sharedList() }">
          <p class="label-negative hmf-mb-0">Sorry, this item is out of stock.</p>
          @if (!sharedList()) {
            <p
              class="hmf-mb-0 underline"
              tabindex="0"
              (click)="ecodeSelectedEmitter()"
              (keydown.enter)="ecodeSelectedEmitter()">
              Shop Similar
            </p>
          }
        </div>
      }

      <a
        class="image no-underline"
        tabindex="-1"
        aria-hidden="true"
        [href]="isDisabled() ? 'javascript:void(0)' : updatedAssetSeoUrl()"
        [class.disabled]="isDisabled()"
        [title]="title()"
        (click)="productCardClicked($event)">
        <!-- Product price, price range, was price ( see price in cart )-->
        @if (!isOOS()) {
          <div class="product-pricing hmf-mb-xs">
            <hmf-price
              variant="vertical"
              [prices]="prices()"
              [isSeePriceInCart]="mapPriceIndicator() === 1"
              [isClearance]="priceIndicator() === 0">
            </hmf-price>
          </div>
        }

        <!-- Customer rating -->

        @if (showCustomerRating()) {
          <div
            class="rating-container"
            [class]="{'hidden': !ratingCount() || !ratingValue()}">
            <hmf-star-ratings
              [ratingCount]="ratingCount()"
              [ratingValue]="ratingValue()"
              [showRating]="false"
              [alignment]="'right'">
            </hmf-star-ratings>
          </div>
        }

        <!-- Promotion Message -->
        <div
          class="hmf-mb-xxs promo-message"
          [class.promo-message--hybrid-pla]="isHybridPLA()"
        >
          @if (promo()) {
            <shared-totf-components-promotion>{{ promo() }}</shared-totf-components-promotion>
          }
        </div>

        @if (availabilityOnProductCardsEnabled()) {
          <hr class="divider hmf-m-0" />
        }

        <!-- availability component -->
        @if (productAvailabilityData() && availabilityOnProductCardsEnabled()) {
          <common-product-availability
            [productAvailabilityData]="productAvailabilityData() ?? undefined"
            [selectedStoreName]="selectedStoreName()"
            [isOOS]="isOOS()"
            [isComingSoon]="isComingSoon()"></common-product-availability>
        }
      </a>
      @if (!productAvailabilityData() && availabilityOnProductCardsEnabled()) {
        <div
          class="hmf-my-xxs availability-loader"></div>
      }

      <div
        class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
        @if (isComingSoon()) {
          <button
            hmf-button
            class="hmf-px-0 hmf-py-0"
            aria-label="Learn More"
            [label]="'Learn More'"
            [size]="'medium'"
            [text]="'Learn More'"
            [variant]="'secondary'"
            (click)="productCardClicked($event)"></button>
        } @else {
          @if (isOOS()) {
            <p class="hmf-label-l out-of-stock hmf-mb-xxxs">OUT OF STOCK</p>
          } @else if (productQuickViewEnabled()) {
            <button
              hmf-button
              id="add-to-cart-button"
              class="hmf-px-0 hmf-py-0"
              [class]="{ 'hmf-px-xs hmf-px-sm-0': chainAbbr() === 'pl' }"
              aria-label="Add To Cart"
              [disabled]="isDisabled()"
              [icon]="atcIcon()"
              [label]="'Add To Cart'"
              [loading]="false"
              [size]="'medium'"
              [text]="'Add To Cart'"
              [variant]="'secondary'"
              (click)="handleQVClick()"></button>
          }
        }
      </div>
      <!-- Compare checkbox -->
      @if (compareCheckboxEnabled()) {
        <div class="compare-checkbox-container hmf-display-flex hmf-justify-content-center">
          <shared-totf-components-compare-checkbox
            class="hmf-display-flex hmf-justify-content-center"
            [checked]="selectedForCompare()"
            (tabPressed)="handleCompareTab()"
            (check)="handleCompareSelection($event)" />
        </div>
        @if (showSkipToComparisonBarButton()) {
          <div class="skip-to-comparison-bar-wrapper hmf-position-absolute hmf-mt-xs">
            <button
              hmf-button
              variant="secondary"
              size="small"
              (blur)="showSkipToComparisonBarButton.set(false)"
              (click)="skipToComparisonBar()">
             Skip to Comparison Bar
            </button>
          </div>
        }
      }
    </div>
  </div>
  <!-- end product card div-->

  @if (isSponsored()) {
    <div
      class="sponsored hmf-legal-s">
      Sponsored
    </div>
  }
</div>
